import { render, staticRenderFns } from "./TrustYouCategory.vue?vue&type=template&id=5f541f46"
import script from "./TrustYouCategory.vue?vue&type=script&lang=js"
export * from "./TrustYouCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrustYouRatingProgress: require('/vercel/path0/components/partials/TrustYouRatingProgress.vue').default})
